export default __webpack_public_path__ + "static/CaseStudyHero-44c04b044a95de7c27f714975ac5edaf.png";